import { ref, onMounted, onUnmounted } from 'vue';

export function useOfferTimer(expiresAt: string) {
  const days = ref(0);
  const hours = ref(0);
  const minutes = ref(0);
  const seconds = ref(0);

  let interval: any;

  const update = () => {
    const now = Date.now();
    const end = new Date(expiresAt).getTime();

    const diff = end - now;

    if (diff <= 0) {
      return;
    }

    days.value = Math.floor(diff / (1000 * 60 * 60 * 24));
    hours.value = Math.floor((diff / (1000 * 60 * 60)) % 24);
    minutes.value = Math.floor((diff / (1000 * 60)) % 60);
    seconds.value = Math.floor((diff / 1000) % 60);
  };

  onMounted(() => {
    update();
    interval = setInterval(update, 1000);
  });

  onUnmounted(() => clearInterval(interval));

  return { days, hours, minutes, seconds };
}
